export default __webpack_public_path__ + "9b3ad0452a73af4a1be3ea9369eea18e.svg";